import {AttributeLink, AttributeSetup} from '@acng/frontend-stargazer';
import {ARRAY, guard, INTEGER, NULLABLE, OBJECT, STRING} from '@acng/frontend-rubicon';
import {TRANSLATIONS} from '../../model';
import {Actor} from '../../layout/context/list.js';
import {AmateurUpgrade, CreatorTemplateConfig} from '../service/template.js';
import {get as httpGet} from 'acng/core/service/backend';
import {make} from '../../core/service/env.js';
import {Portal} from '../../portal.js';
import {get} from '../service/cache.js';
import {extend} from '@acng/frontend-bounty/object.js';

/**
 * @group DOM Attribute
 */
const name = 'moderated-amateur-list';

const MODERATED_AMATEUR = /* @__PURE__ */ OBJECT({
  amateur_id: INTEGER,
  nickname: STRING,
  image_url: STRING,
  description: NULLABLE(TRANSLATIONS),
});

AttributeSetup(name, (name) => {
  const provideList = Actor();

  /**
   * @param {number} offset
   */
  const getMore = async (offset) => {
    if (offset) {
      return [];
    }

    const url = `amateur-profile/moderated-list/${make(Portal).abbr}`;
    const list = await httpGet(url);
    ASSERT: guard(list, ARRAY(MODERATED_AMATEUR), `decoded response from ${url}`);

    return list;
  };

  /**
   * @param {Valid<MODERATED_AMATEUR>} item
   *
   * @returns {Promise<
   *   import('@acng/frontend-stargazer').ElementLinkCallback<HTMLElement>
   * >}
   */
  const makeLinkFn = async ({amateur_id, nickname, description, image_url}) => {
    const proto = await get(`${amateur_id}`);
    const amateur = extend(proto, {nickname, intlname: nickname, description});
    const config = CreatorTemplateConfig(amateur);
    config.image = image_url;
    config.url = '/none';

    return AmateurUpgrade(amateur, config);
  };

  AttributeLink(name, (element) => provideList(element, getMore, makeLinkFn));
});

export {name as MODERATED_AMATEUR_LIST};
